import { defineMessages } from 'react-intl';

export const messages: {
	dynamic_layout_list_project_status_merged: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	dynamic_layout_list_see_more: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	dynamic_layout_list_see_less: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	dynamic_layout_list_project_status_merged: {
		id: 'search_ai.dynamic_layout_list_project_status_merged',
		defaultMessage: 'Merged',
		description:
			'Status label shown in a lozenge badge on a dynamic layout list item when the associated project item has been merged.',
	},
	dynamic_layout_list_see_more: {
		id: 'search_ai.dynamic_layout_list_see_more',
		defaultMessage: 'See more',
		description:
			'Text shown on the button that expands a collapsed list in the dynamic layout component to reveal additional items.',
	},
	dynamic_layout_list_see_less: {
		id: 'search_ai.dynamic_layout_list_see_less',
		defaultMessage: 'See less',
		description:
			'Text shown on the button that collapses an expanded list in the dynamic layout component to hide extra items.',
	},
});
